// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qezamzhihswinaufhtqb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFlemFtemhpaHN3aW5hdWZodHFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1MTM3MjMsImV4cCI6MjA1MzA4OTcyM30.SEnhI9qsE3kueB2Gc1Awk2D3A7qnphtydhtRFhzrX6Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);